import { useRegisterAgentContext } from '@backrs_ui/grow-ui/src/agentContext/useRegisterAgentContext';
import { appStrings } from '@backrs_ui/grow-ui/src/assets/appStrings';

import { ANALYTICS_TAB_LABEL, type AnalyticsTab } from './analytics.tabs';

const { coachingAnalytics } = appStrings.modules;

/**
 * Framing for the page as a whole. Each card registers its own figures, so what
 * belongs here is only what no single card can say.
 */
export const useAgentContext = (tab: AnalyticsTab | null) => {
  useRegisterAgentContext(tab ? { kind: 'tab', title: ANALYTICS_TAB_LABEL[tab] } : null);

  useRegisterAgentContext({
    kind: 'section',
    title: 'Reading these numbers',
    description:
      'Every figure is an aggregate over the students matching the dashboard filters, and each carries its own denominator, which differs by card. Quote a figure with the population it came from, and say when a bin, category or bar rests on only a handful of students: at one or two students an aggregate describes those individuals rather than a pattern, so call that out instead of reading a trend into it.',
  });

  useRegisterAgentContext(
    tab === 'overview'
      ? {
          kind: 'section',
          title: coachingAnalytics.successSystem.title,
          description: coachingAnalytics.successSystem.description,
        }
      : null,
  );
};
